import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative inline-flex items-center justify-center px-8 py-4 
        text-lg font-bold text-navy bg-gold rounded-lg shadow-lg
        hover:bg-gold-light transition-colors duration-300
        animate-pulse-gold
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-158">
      {children}
    </motion.button>;
}